<template>
    <DForm @submit.prevent="submitForm">
        <DCard
            :title="__('settings.messenger_settings.name')"
            :padding="true"
            class="mb-4"
        >
            <DFormRow
                :label="__('settings.messenger_settings.form.api_url')"
                :is-required="true"
                :hint="__('settings.messenger_settings.form.api_url_hint')"
            >
                <DInput
                    id="messenger_settings_api_url"
                    v-model="form.api_url"
                    :placeholder="__('settings.messenger_settings.form.api_url')"
                    :is-valid="isFormFieldValid('api_url')"
                    :invalid-feedback="errors.api_url"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.messenger_settings.form.client_id')"
                :is-required="true"
                :hint="__('settings.messenger_settings.form.client_id_hint')"
            >
                <DInput
                    id="messenger_settings_client_id"
                    v-model="form.client_id"
                    :placeholder="__('settings.messenger_settings.form.client_id')"
                    :is-valid="isFormFieldValid('client_id')"
                    :invalid-feedback="errors.client_id"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.messenger_settings.form.client_secret')"
                :is-required="true"
                :hint="__('settings.messenger_settings.form.client_secret_hint')"
            >
                <DInput
                    id="messenger_settings_client_secret"
                    v-model="form.client_secret"
                    :placeholder="__('settings.messenger_settings.form.client_secret')"
                    :is-valid="isFormFieldValid('client_secret')"
                    :invalid-feedback="errors.client_secret"
                    type="text"
                />
            </DFormRow>
            <DRow>
                <DCol sm="4" />
                <DCol sm="4">
                    <div
                        v-if="connectionStatus === 'successful'"
                        class="green-text"
                    >
                        {{ __('settings.messenger_settings.messages.connection_successful') }}
                    </div>
                    <div
                        v-if="connectionStatus === 'unsuccessful'"
                        class="text-danger"
                    >
                        {{ __('settings.messenger_settings.messages.connection_unsuccessful') }}
                    </div>
                </DCol>
                <DCol
                    sm="4"
                    class="check-database-connection-btn"
                >
                    <DButton
                        icon="lan-connect"
                        :label="__('settings.messenger_settings.check_connection')"
                        :disabled="isInLoadingState"
                        @click="checkConnection"
                    />
                </DCol>
            </DRow>
        </DCard>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
    <DConnectionErrorModal
        :show-modal="connectionException !== null"
        :exception="connectionException"
        @close-modal="closeModal"
    />
</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    messengerSettings: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const connectionStatus = ref(null)
const connectionException = ref(null)
const emit = defineEmits(['form-submitted'])

const form = useForm({
    api_url: props.messengerSettings?.api_url ?? '',
    client_id: props.messengerSettings?.client_id ?? '',
    client_secret: props.messengerSettings?.client_secret ?? '',
})

const submitForm = () => {
    emit('form-submitted', form)
}
const checkConnection = (client) => {
    connectionException.value = null
    form.client = client
    window.axios.post(route('settings.messenger-settings.check', form))
        .then(function () {
            connectionStatus.value = 'successful'
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'
            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        }
        )
}

function closeModal () {
    connectionException.value = null
}
</script>

<style scoped lang="scss">
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 12px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
